import {useState, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../../selectors/modals/wallet/methods/googlepay_deposit/stage';
import {createOrder} from '../../../../../reducers/wallet/actions/googlepay_deposit';
import {setPreset} from '../../../../../reducers/wallet/actions';
import {NumericFormat} from 'react-number-format';
import FormInput from '../../../../components/form-input';
import BlueButton from '../../../../components/blue-button';
import ModalsLib from '../../../../../lib/modals';

export default () => {
    const {props} = useSelector(Selector),
          dispatch = useDispatch();

    const inputRef = useRef();
    const [state, setState] = useState({
        amount: props.amount
    });

    const setAmount = amount => {
        setState({
            ...state,
            amount
        });
    }

    return (
        <>
            <div className="modal-header">
                <div className="modal-header-left">
                    <div className="title">Google Pay</div>
                    <div className="descriptions">Enter the deposit amount and go to the payment page</div>
                </div>
                <div className="close" onClick={e => ModalsLib.close()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className="modal-body"> 
                <div className="amount-block">
                    <div className="label">Enter deposit amount</div>
                    <div className="input">
                        <div className="edit">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.2633 5.43908L5.05327 14.1291C4.74327 14.4591 4.44327 15.1091 4.38327 15.5591L4.01327 18.7991C3.88327 19.9691 4.72327 20.7691 5.88327 20.5691L9.10327 20.0191C9.55327 19.9391 10.1833 19.6091 10.4933 19.2691L18.7033 10.5791C20.1233 9.07908 20.7633 7.36908 18.5533 5.27908C16.3533 3.20908 14.6833 3.93908 13.2633 5.43908Z" stroke="#4FACFE" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M11.8933 6.88916C12.3233 9.64916 14.5633 11.7592 17.3433 12.0392" stroke="#4FACFE" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>

                        <NumericFormat  
                            displayType='input'
                            type='tel'
                            value={state.amount === 0 ? '' : state.amount}
                            placeholder='$0.00'
                            prefix={'$'} 
                            decimalSeparator="." 
                            decimalScale={0} 
                            thousandSeparator=" "
                            maxLength={8}
                            getInputRef={inputRef}
                            autoFocus={true}
                            onValueChange={(values) => {
                                setState({
                                    ...state,
                                    amount: values.floatValue
                                })
                            }} />

                        <div className="clear" onClick={e => setAmount(0)}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 18L18 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M18 18L6 6" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>
                    </div>

                    <div className="buttons">
                        <div className="amounts">
                            <div className={`amount active`} onClick={e => setAmount((state.amount || 0) + 5)}>+5</div>
                            <div className={`amount active`} onClick={e => setAmount((state.amount || 0) + 10)}>+10</div>
                            <div className={`amount active`} onClick={e => setAmount((state.amount || 0) + 25)}>+25</div>
                            <div className={`amount active`} onClick={e => setAmount((state.amount || 0) * 2)}>X2</div>
                            <div className={`amount clear`} onClick={e => setAmount('')}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21 5.97998C17.67 5.64998 14.32 5.47998 10.98 5.47998C9 5.47998 7.02 5.57998 5.04 5.77998L3 5.97998" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M18.85 9.14001L18.2 19.21C18.09 20.78 18 22 15.21 22H8.79002C6.00002 22 5.91002 20.78 5.80002 19.21L5.15002 9.14001" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M10.33 16.5H13.66" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M9.5 12.5H14.5" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>

                            {/* <div className={`amount ${state.amount === 60 ? 'active' : ''}`} onClick={e => setAmount(60)}>$60</div> */}
                            {/* <div className={`amount hot ${state.amount === 30 ? 'active' : ''}`} onClick={e => setAmount(30)}>
                                <div className="hot">
                                    <span>HOT</span>
                                </div>
                                $30
                            </div> */}
                        </div>
                    </div>
                </div>

                <hr />

                {props.error && (
                    <div class="modal-message warning">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 7.75V13" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M21.0802 8.58003V15.42C21.0802 16.54 20.4802 17.58 19.5102 18.15L13.5702 21.58C12.6002 22.14 11.4002 22.14 10.4202 21.58L4.48016 18.15C3.51016 17.59 2.91016 16.55 2.91016 15.42V8.58003C2.91016 7.46003 3.51016 6.41999 4.48016 5.84999L10.4202 2.42C11.3902 1.86 12.5902 1.86 13.5702 2.42L19.5102 5.84999C20.4802 6.41999 21.0802 7.45003 21.0802 8.58003Z" stroke="#DA6C0C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M12 16.2V16.2999" stroke="#DA6C0C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                        <span dangerouslySetInnerHTML={{__html: props.error}}></span>
                    </div>
                )}
            </div>
            <div className="modal-footer">
                <BlueButton disabled={state.amount < 10} active={props.button} onClick={e => {
                    dispatch(createOrder({
                        amount: state.amount
                    }));
                }}>
                    Continue
                </BlueButton>
                <div className="button back" onClick={e => dispatch(setPreset({
                    mode: 'tabs',
                    method: null
                }))}>
                    Back
                </div>
            </div>
        </>
    )
}